// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"899a4cda","626":"5b65cc6c","744":"b10b786d","943":"7c90b345"}[chunkId] + ".chunk.js";
};